export default __webpack_public_path__ + "static/ti_hovercaravan_block-036a750b17f2f875c10261d3080981fd.svg";